<template>
    <div>
        HELLO
        <div style="" class="mindmap">
            <ol class="children children_leftbranch">
                <li class="children__item">
                    <div class="node">
                        <div class="node__text">Node</div>

                    </div>
                    <ol class="children">
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">Node</div>

                            </div>
                        </li>
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">Node</div>

                            </div>
                        </li>
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">Node</div>

                            </div>
                        </li>
                    </ol>
                </li>
                <li class="children__item">
                    <div class="node">
                        <div class="node__text">node</div>

                    </div>
                    <ol class="children">
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">node</div>

                            </div>
                        </li>
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">node</div>

                            </div>
                        </li>
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">node</div>

                            </div>
                        </li>
                    </ol>
                </li>
                <li class="children__item">
                    <div class="node">
                        <div class="node__text">node</div>

                    </div>
                    <ol class="children">
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">node</div>

                            </div>
                        </li>
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">node</div>

                            </div>
                        </li>
                        <li class="children__item">
                            <div class="node">
                                <div class="node__text">node</div>

                            </div>
                        </li>
                    </ol>
                </li>
            </ol>
            <div class="node node_root">
                <div class="node__text">node</div>

            </div>



        </div>
    </div>
</template>

<script type="text/javascript">
$(function() {

});



export default {
    mounted() {
        //console.log(this.assets_mindmap);
        //$('.mindmap').mindmap();
        $('.mindmap').mindmap();

    },
    data () {
        return {
            value: [],
            list: []
        }
    },
    methods: {

    },
    props: {


    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
